import type { LvMatch, PlanV3 } from "./types";

interface SetRouteGroupLvMatchInPlanArgs {
  plan: PlanV3;
  routeGroupLabel: string;
  lvMatch: LvMatch;
}

export const setRouteGroupLvMatchInPlan = ({
  plan,
  routeGroupLabel,
  lvMatch,
}: SetRouteGroupLvMatchInPlanArgs): PlanV3 => {
  const targetIndex = plan.routeGroups.findIndex(
    (group) => group.label === routeGroupLabel,
  );
  if (targetIndex === -1) return plan;

  const targetGroup = plan.routeGroups[targetIndex];
  const updatedRoutes = targetGroup.routes.map((route) => ({
    ...route,
    lv_position: lvMatch.lvId ?? "",
    lvMatch,
  }));

  const routeGroups = [...plan.routeGroups];
  routeGroups[targetIndex] = { ...targetGroup, routes: updatedRoutes };

  return { ...plan, routeGroups };
};
